export var PartnerBadgeEnum;
(function (PartnerBadgeEnum) {
    PartnerBadgeEnum["diamond"] = "Diamond Partner";
    PartnerBadgeEnum["platin"] = "Platin Partner";
    PartnerBadgeEnum["simple"] = "immowelt Partner";
    PartnerBadgeEnum["premium"] = "Premium Partner";
    PartnerBadgeEnum["business"] = "Business Partner";
})(PartnerBadgeEnum || (PartnerBadgeEnum = {}));
export var PublisherTypeEnum;
(function (PublisherTypeEnum) {
    PublisherTypeEnum["AGENCY"] = "provider.publisher_type.agency";
    PublisherTypeEnum["AGENT"] = "provider.publisher_type.agent";
    PublisherTypeEnum["NOTARY"] = "provider.publisher_type.notary";
    PublisherTypeEnum["BUILDER"] = "provider.publisher_type.builder";
    PublisherTypeEnum["PROMOTOR"] = "provider.publisher_type.promotor";
})(PublisherTypeEnum || (PublisherTypeEnum = {}));
export var SALUTATION;
(function (SALUTATION) {
    SALUTATION["MR"] = "mr";
    SALUTATION["MRS"] = "mrs";
    SALUTATION["DIVERSE"] = "diverse";
})(SALUTATION || (SALUTATION = {}));
export var PROFILE_STATUS;
(function (PROFILE_STATUS) {
    PROFILE_STATUS["EMPTY"] = "empty";
    PROFILE_STATUS["STARTED"] = "started";
    PROFILE_STATUS["SHAREABLE"] = "shareable";
})(PROFILE_STATUS || (PROFILE_STATUS = {}));
